import { AxiosResponse } from 'axios';

import { axiosIntance } from '../../../config/ApiConfig';
import {
  PrintingService,
  PrintingServiceList,
  ResponsePrintingServiceProps,
} from '../../../types/printingService/PrintingService';

export const PrintingServiceDao = {
  listPrintingServices: (
    accountId: string,
    page: number,
    limit: number,
    search: string | null,
    filter: string | null
  ): Promise<AxiosResponse<ResponsePrintingServiceProps>> => {
    let query = '';
    if (search) {
      query = `&filter=${search}`;
    }
    if (filter) {
      filter = `&${filter}`;
    } else {
      filter = '';
    }
    if (!page) {
      page = 1;
    }
    if (!limit) {
      limit = 20;
    }
    return axiosIntance.get(
      `/accountSettingsPrinter/list?accountId=${accountId}&page=${page}&limit=${limit}${query}${filter}`
    );
  },

  showPrintingService: (
    id: string,
    accountId: string
  ): Promise<AxiosResponse<PrintingService>> => {
    return axiosIntance.get(`accountSettingsPrinter/${accountId}/${id}`);
  },

  printingServiceList: (
    accountId: string
  ): Promise<AxiosResponse<PrintingServiceList[]>> => {
    return axiosIntance.get(`settings/printer/list?account=${accountId}`);
  },
};
